import { PageSettingsPatch } from '@storefronts/common-types'
import { deepEqual } from '@/lib/utils'

const PAGE_SETTING_GROUPS: {
    keys: (keyof PageSettingsPatch)[]
    label: string
}[] = [
    { keys: ['title'], label: 'title' },
    { keys: ['bannerText'], label: 'banner text' },
    { keys: ['ctaPulseEnabled'], label: 'CTA pulse' },
    { keys: ['dynamicCartUpsellsEnabled'], label: 'cart upsells' },
    {
        keys: ['desktopRedirectEnabledOverride', 'desktopRedirectUrlOverride'],
        label: 'desktop redirect',
    },
    { keys: ['bannerBenefits'], label: 'banner benefits' },
    {
        keys: ['discountCode', 'discountType', 'discountValue'],
        label: 'discount',
    },
]

/** Fills omitted page-setting fields so undefined vs '' vs null do not look like edits. */
export function snapshotPageSettings(
    pageSettings: PageSettingsPatch = {},
): PageSettingsPatch {
    return {
        title: pageSettings.title ?? '',
        bannerText: pageSettings.bannerText ?? '',
        ctaPulseEnabled: pageSettings.ctaPulseEnabled ?? false,
        dynamicCartUpsellsEnabled:
            pageSettings.dynamicCartUpsellsEnabled ?? true,
        desktopRedirectEnabledOverride:
            pageSettings.desktopRedirectEnabledOverride ?? null,
        desktopRedirectUrlOverride:
            pageSettings.desktopRedirectUrlOverride ?? null,
        bannerBenefits: pageSettings.bannerBenefits ?? [],
        discountCode: pageSettings.discountCode ?? null,
        discountType: pageSettings.discountType ?? null,
        discountValue: pageSettings.discountValue ?? null,
    }
}

/** Short history-panel summary of page-setting edits, e.g. "Edited title; Edited discount". */
export function summarizePageSettingsDiff(
    before: PageSettingsPatch,
    after: PageSettingsPatch,
): string {
    const previous = snapshotPageSettings(before)
    const next = snapshotPageSettings(after)
    const parts: string[] = []
    for (const group of PAGE_SETTING_GROUPS) {
        const changed = group.keys.some(
            (key) => !deepEqual(previous[key], next[key]),
        )
        if (changed) {
            parts.push(`Edited ${group.label}`)
        }
    }
    return parts.length ? parts.join('; ') : 'No changes'
}
